import {
    TSPAY_ONBOARDING_START,
    TSPAY_ONBOARDING_SUCCESS,
    TSPAY_ONBOARDING_ERROR,
    TSPAY_ONBOARDING_RESET
} from "../../actions/services/tspay.js";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export default function tspayOnboarding(state = defaultState, { type, payload, error }) {
    switch (type) {
        case TSPAY_ONBOARDING_START:
            return {
                status: {
                    ...defaultState.status,
                    started: true
                }
            };
        case TSPAY_ONBOARDING_SUCCESS:
            return {
                status: {
                    ...defaultState.status,
                    ended: true
                },
                ...payload
            };
        case TSPAY_ONBOARDING_ERROR:
            return {
                status: {
                    ...defaultState.status,
                    error: true,
                    errorInfo: { code: error.code, message: error.message, itemId: payload.itemId }
                }
            };
        case TSPAY_ONBOARDING_RESET:
            return {
                ...defaultState
            };
        default:
            return state;
    }
}
